import { render } from "./LatestVideos.vue?vue&type=template&id=cce0d932"
import script from "./LatestVideos.vue?vue&type=script&lang=js"
export * from "./LatestVideos.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__